import React, { Component } from 'react';
import SearchLayout from './SearchLayout';
import '../css/style.css';
import '../components/Home.css';
import WithSearchLayout from './WithSearchLayout';
import { translate } from "react-i18next";


class MyBookedsLayout extends Component {

       render(){
        const { t } = this.props;
        const { params } = this.props.match
         return (<SearchLayout title={t("myBookings")} eventKey="3" >
         <WithSearchLayout preURL="p-events/myBooked" id={params.id} />
     </SearchLayout>)
       }
}

export default translate("translations")(MyBookedsLayout);